<div class="modal-container">
    <div class="modal-container-body">
        <div class="customization-design-container">
            <!-- Left bloc -->
            <div class="customization-design-left-box">
                <!-- Customization header -->
                <div class="customization-design-left-box-header" [@animateHeader]="customizationEdited ? 'out' : 'in'">
                    <div class="customization-design-left-box-header-back" (click)="ref.close()">
                        <div class="icon-smash_back back-icon">
                        </div>
                        <div>{{ 'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_BUTTON_LABEL_BACK' | translate }}</div>
                    </div>
                    <div>
                        <span class="customization-design-left-box-header-button" (click)="save()">{{
                            'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_BUTTON_LABEL_SAVE' | translate }}</span>
                        <span class="customization-design-left-box-header-button" (click)="ref.close()">{{
                            'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_BUTTON_LABEL_CANCEL' | translate }}</span>
                    </div>
                </div>
                <div class="customization-design-left-box-text-content">
                    <h1>{{'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_TITLE' | translate }}</h1>
                    <p>{{'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_TEXT' | translate }}</p>
                </div>

                <!-- Group customization buttons -->
                <div class="customization-design-left-box-button-group">
                    <button [ngClass]="{'selected': selectedSection === 'backgrounds'}" (click)="onSwitchBackgroundSection()">{{
                        'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_TAB_BACKGROUND' | translate }}</button>
                    <button [ngClass]="{'selected': selectedSection ==='logos'}" (click)="onSwitchLogoSection()">{{
                        'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_TAB_LOGO' | translate }}
                    </button>
                </div>

                <!-- customization thumbnails container -->
                <div class="customization-design-left-box-thumbnails-container">
                    <!-- WallPaper List -->
                    <ng-container *ngIf="backgrounds; else noBackgrounds">
                        <ul class="customization-design-left-box-thumbnails-list" [ngClass]="{'displayed': selectedSection ==='backgrounds'}">
                            <li (click)="onAddBackground()" class="customization-design-left-box-thumbnails-list-item ">
                                <div class="customization-design-left-box-thumbnails-list-item-content">
                                    <span>{{ 'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_ADD_BACKGROUND_LOGO' | translate }}</span>
                                </div>
                            </li>
                            <li *ngFor="let background of backgrounds" class="customization-design-left-box-thumbnails-list-item"
                                (click)="onSelectBackground(background)" [ngClass]="{'selected': isBackgroundSelected(background)}"
                                appBackgroundImage="{{ background.thumbnail }}">
                                <div class="customization-design-left-box-thumbnails-list-item-overlay">
                                    <div class="customization-design-left-box-thumbnails-list-item-overlay-checked"
                                        *ngIf=" isBackgroundSelected(background)">
                                        <i class="icon-smash_check"></i>
                                    </div>
                                    <div class="customization-design-left-box-thumbnails-list-item-overlay-media-icon"
                                        *ngIf="background.type === 'Youtube' || background.type === 'Vimeo'">
                                        <i class="icon-smash_videos"></i>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </ng-container>
                    <ng-template #noBackgrounds>
                        <ul class="customization-design-left-box-thumbnails-list" [ngClass]="{'displayed': selectedSection ==='backgrounds'}">
                            <li (click)="onAddBackground()" class="customization-design-left-box-thumbnails-list-item ">
                                <div class="customization-design-left-box-thumbnails-list-item-content">
                                    <span>{{ 'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_ADD_BACKGROUND_LOGO' | translate }}</span>
                                </div>
                            </li>
                        </ul>
                    </ng-template>


                    <!-- Logos List -->
                    <ng-container *ngIf="logos; else noLogos">
                        <ul class="customization-design-left-box-thumbnails-list items" [ngClass]="{'displayed': selectedSection ==='logos'}">
                            <li class="customization-design-left-box-thumbnails-list-item item">
                                <div class="customization-design-left-box-thumbnails-list-item-content" (click)="lockFreemium()">
                                    <input type="file" class="customization-design-left-box-logo-input"
                                        (change)="createLogo($event.target.files); this.value=null;">
                                    <span>{{ 'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_ADD_IMAGE' | translate }}</span>
                                </div>
                            </li>
                            <li *ngFor="let logo of logos" class="customization-design-left-box-thumbnails-list-item" (click)="onSelectLogo(logo)"
                                [ngClass]="{'selected': isLogoSelected(logo)}" appBackgroundImage="{{ logo.thumbnail }}">
                                <div class="customization-design-left-box-thumbnails-list-item-content">
                                </div>
                                <div class="customization-design-left-box-thumbnails-list-item-overlay">
                                    <div class="customization-design-left-box-thumbnails-list-item-overlay-checked" *ngIf=" isLogoSelected(logo)">
                                        <i class="icon-smash_check"></i>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </ng-container>
                    <ng-template #noLogos>
                        <ul class="customization-design-left-box-thumbnails-list items" [ngClass]="{'displayed': selectedSection ==='logos'}">
                            <li class="customization-design-left-box-thumbnails-list-item item">
                                <div class="customization-design-left-box-thumbnails-list-item-content">
                                    <input type="file" class="customization-design-left-box-logo-input"
                                        (change)="createLogo($event.target.files); this.value=null;" (click)="lockFreemium()">
                                    <span>{{ 'UPLOADER_CUSTOMIZATION_MODAL_RECEIVER_ADD_IMAGE' | translate }}</span>
                                </div>
                            </li>
                        </ul>
                    </ng-template>

                </div>
            </div>

            <!-- Right Bloc -->
            <div class="customization-design-right-box">
                <!-- loader overlay -->
                <div class="customization-design-right-box-loader" *ngIf="backgroundIsLoading">
                    <app-smash-loading-spinner></app-smash-loading-spinner>
                </div>
                <!-- Customization viewer preview desktop -->
                <div class="preview-customization-container" *ngIf="previewCustomizationReady">
                    <app-smash-previewer-customization [customization]="customizationEdited" customizationAim="receiver"
                        displayType="fullscreen" componentSource="modal-customization-receiver" [url]="(domain$ | async)?.domain">
                    </app-smash-previewer-customization>
                </div>
            </div>
        </div>
    </div>
</div>